import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

function OliPrivateRoute({ element }: { element: JSX.Element }) {
    const [isLoggedIn] = useState(() => {
      return localStorage.getItem('isOliLoggedIn') === 'true';
    });
  
    useEffect(() => {
      localStorage.setItem('isOliLoggedIn', JSON.stringify(isLoggedIn));
    }, [isLoggedIn]);
    
    return isLoggedIn ? element : <Navigate to="/OliLogin" />;
  }

  export default OliPrivateRoute;
